/**
 * Datumtekst van een Print.com-leverdatum ("do 19 nov – vr 20 nov"), gedeeld
 * door de prijsmatrix op de productpagina (use-printcom-delivery-availability.ts)
 * en de chatbot-tools, zodat de bot exact dezelfde tekst noemt als de site.
 *
 * Client-veilig: geen database of server-import.
 */

const INTL_LOCALE: Record<string, string> = { nl: 'nl-NL', en: 'en-GB', de: 'de-DE', fr: 'fr-FR' };

function isoDay(value: unknown): Date | null {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(`${value}T12:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? date : null;
}

function formatter(locale: string) {
  const language = String(locale || 'nl').split('-')[0];
  return new Intl.DateTimeFormat(INTL_LOCALE[language] || 'en-GB', {
    weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/Amsterdam',
  });
}

/** Eén dag (JJJJ-MM-DD) als "vr 23 okt", of null bij een ongeldige datum. */
export function formatDeliveryDay(isoDate: unknown, locale: string): string | null {
  const date = isoDay(isoDate);
  return date ? formatter(locale).format(date) : null;
}

/**
 * Bevestigde leverdatum met eventueel de laatste dag van het venster, of null
 * als er geen geldige bevestigde datum is.
 */
export function formatDeliveryWindow(
  result: { status?: string; deliveryDate?: string; latestDeliveryDate?: string } | undefined | null,
  locale: string,
): string | null {
  if (result?.status !== 'confirmed') return null;
  const planned = formatDeliveryDay(result.deliveryDate, locale);
  if (!planned) return null;
  const latest = result.latestDeliveryDate && result.latestDeliveryDate > String(result.deliveryDate)
    ? formatDeliveryDay(result.latestDeliveryDate, locale)
    : null;
  return latest ? `${planned} – ${latest}` : planned;
}
